import React from 'react';

import { Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Tooltip,Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

import useTableStyling from '../../hooks/useTableStyling';

const useStyles = makeStyles( (mainTheme) => ({
  mobileTextTitleStyle:{
    marginLeft:"5px",
    fontSize:"11px",
    color: mainTheme.palette.tertiary.main
    },
  table: {
    minWidth: 360,
    height:"100%",
  },
  tableTitle: {
    width:"22%",
    paddingLeft:"6px",
    paddingRight:"0px",
    fontSize: 11,
    [mainTheme.breakpoints.down('sm')]: {
      fontSize: "9px"
    },
    color: "white",
    backgroundColor: mainTheme.palette.primary.main,
  },  
  firstColumnWhiteStyle: {
    minWidth:"145px",
    [mainTheme.breakpoints.down('sm')]: {
      minWidth: "90px"
    },
    paddingLeft:"6px",
    paddingRight:"0px",
    fontSize:"9px",
    color:mainTheme.palette.primary.main,
    backgroundColor:"whitesmoke"
  },  
  firstColumnGrayStyle: {
    minWidth:"145px",
    [mainTheme.breakpoints.down('sm')]: {
      minWidth: "90px"
    },
    paddingLeft:"6px",
    paddingRight:"0px",
    fontSize:"9px",
    color:mainTheme.palette.primary.main,
    backgroundColor: mainTheme.palette.contrast.main
  },
  dataColumnWhiteStyle:{
    paddingLeft:"4px",
    paddingRight:"8px",
    fontSize: "9px",
    [mainTheme.breakpoints.down('sm')]: {
      fontSize: "9px"
    },
    color:mainTheme.palette.primary.main,
    backgroundColor: "whitesmoke",
  },
  dataColumnGrayStyle:{
    paddingLeft:"4px",
    paddingRight:"8px",
    fontSize: "9px",
    [mainTheme.breakpoints.down('sm')]: {
      fontSize: "9px"
    },
    color:mainTheme.palette.primary.main,
    backgroundColor: mainTheme.palette.contrast.main
  },
  yearColumnStyle:{
    paddingLeft:"4px",
    paddingRight:"8px",
    fontSize: "11px",
    [mainTheme.breakpoints.down('sm')]: {
      fontSize: "10px"
    },
    color: "white",
  }
  }));

export default function TableCashFlow ({combinedFinancialData, assumptions, isCheckedShowPreviousYears, isCheckedDescOrder, isEstimateFcffOnly}){ 
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { defineYearsColWidth, defineYearsColColor, defineYearsColBackColor, defineNumberFormat } = useTableStyling();
  // const cashFlowDiscretePeriod = { assumptions }

  const dataRows = [
    { id: 0,
      rowText:"Earnings Before Interest & Taxes",
      rowMobileText:"EBIT",
      grayBackground:true,
      showAsBlankIfZero:true,  
      style:"decimal",
      dataField:"ebit" },
    { id: 1,
      rowText:"(-) Income Taxes",
      rowMobileText:"(-) Taxes",
      grayBackground:false,
      showAsBlankIfZero:true,
      style:"decimal",
      dataField:"incomeTaxExpense" },  
    { id: 2,
      rowText:"(+) Depreciation",
      rowMobileText:"(+) Depreciation",
      grayBackground:false,
      showAsBlankIfZero:true,
      style:"decimal",
      dataField:"depreciation"}, 
    { id: 3,
      rowText:"(-) Capex",
      rowMobileText:"(-) Capex",
      grayBackground:false,
      showAsBlankIfZero:true,
      style:"decimal",
      dataField:"capitalExpenditures"},  
    { id: 4,
      rowText:"(-) Net Working Capital Changes",
      rowMobileText:"(-) NWC Changes",
      grayBackground:false,
      showAsBlankIfZero:true,
      style:"decimal",
      dataField:"workingCapitalChanges"},
    { id: 5,
      rowText:"Free Cash Flow to the Firm",
      rowMobileText:"FCFF",
      grayBackground:true,
      showAsBlankIfZero:false,
      style:"decimal",
      dataField: "cashFlow"}, 
    { id: 6,
      rowText:"Discounted FCFF",
      rowMobileText:"Discounted FCFF",
      grayBackground:true,
      showAsBlankIfZero:true,
      style:"decimal",
      dataField: "discountedCashFlow"} 
  ]

  function tableTitleText (isMobile, cashFlowDiscretePeriod ) {
    if (isMobile){
      return ""
    }
    if (cashFlowDiscretePeriod < 8){
      return "Free Cash Flow to the Firm"
    }
      return "Free Cash Flow to the Firm" // "FCFF"
  }
  return (
    <>
    <Paper>
      {isMobile? <Typography gutterBottom className={classes.mobileTextTitleStyle}  style={{fontSize:"12px"}}><b>Free Cash Flow to the Firm (in USD bilions)</b></Typography> : null}
      <TableContainer component = {Paper}>
      <Table className = {classes.table} size="small" aria-label="stycky header">

        <TableHead >
          <TableRow>
            <Tooltip title="Free Cash Flow to the Firm">
            <TableCell className={classes.tableTitle} align="left" >{tableTitleText(isMobile, assumptions.cashFlowDiscretePeriod)}</TableCell>  
            </Tooltip>
            {combinedFinancialData.map ((currElement, index) => ( 
              <TableCell className={classes.yearColumnStyle} align="right" style={{color:defineYearsColColor(index, assumptions, isCheckedShowPreviousYears, isCheckedDescOrder), backgroundColor:defineYearsColBackColor(index, assumptions, isCheckedShowPreviousYears, isCheckedDescOrder), width:defineYearsColWidth(assumptions, isCheckedShowPreviousYears)}}>{currElement.year}</TableCell>
            ))} 
          </TableRow>
        </TableHead>

        <TableBody>
    
        {dataRows.map ((accountElement)=> (
    
          <TableRow>  
            <TableCell align="left" className = {accountElement.grayBackground ? classes.firstColumnGrayStyle : classes.firstColumnWhiteStyle } >{isMobile  ? accountElement.rowMobileText: accountElement.rowText}</TableCell>
            {combinedFinancialData.map ((yearElement) => ( 
              <>
              {/* if account is depreciation change sign to positive number */}
              { accountElement.dataField === "depreciation" && [yearElement[accountElement.dataField]] < 0 ? 
                <TableCell align="right" className = {accountElement.grayBackground ? classes.dataColumnGrayStyle : classes.dataColumnWhiteStyle} style = {{ width:defineYearsColWidth(assumptions, isCheckedShowPreviousYears)}} >{defineNumberFormat([yearElement[accountElement.dataField]]*-1, [accountElement.style], [accountElement.showAsBlankIfZero],[accountElement.dataField],isEstimateFcffOnly,assumptions.cashFlowDiscretePeriod) }</TableCell>  
                : 
                <TableCell align="right" className = {accountElement.grayBackground ? classes.dataColumnGrayStyle : classes.dataColumnWhiteStyle} style = {{ width:defineYearsColWidth(assumptions, isCheckedShowPreviousYears)}} >{defineNumberFormat([yearElement[accountElement.dataField]], [accountElement.style], [accountElement.showAsBlankIfZero],[accountElement.dataField],isEstimateFcffOnly,assumptions.cashFlowDiscretePeriod) }</TableCell>
              }
              </>
            ))}
          </TableRow>
        ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
  </>
  )
}